import { RichText } from './rich-text';

export class QuestionOption {
  content: RichText;
  id: number;
  idx: number;
  standard: boolean;
  // åªç¨äºé¡µé¢æ¾ç¤º
  showDelBtn?: boolean;


  constructor() {
    this.content = new RichText();
    this.standard = false;
    this.showDelBtn = false;
  }
}
